import { useCoingeckoTokenListQuery } from '@/services/TokenList'
import { Token } from '@/types/tokens'

export function useImportableTokens(): Token[] {
  const coingeckoListQuery = useCoingeckoTokenListQuery()

  return coingeckoListQuery?.data?.tokens || []
}
